const { filter, some } = require('lodash'), { createProductTiles, createBundleTiles } = require('../shop/tiles/product-tile-factory');

class SearchProductTileListController {
    constructor(settings, analyticsService, searchService, sortByKeys, pageBannerStateService) {
        this.settings = settings;
        this.analyticsService = analyticsService;
        this.searchService = searchService;
        this.sortByKeys = sortByKeys;
        this.pageBannerStateService = pageBannerStateService;
    }

    $onChanges(changes) {
        if (changes.filter) {
            this.sortOptions = {
                sortContext: this.sortByKeys.SEARCH_RESULTS_KEY,
                sortTypes: this.getSortTypes(this.settings.search.sortOptions),
            };
        }
    }

    getSortTypes(sortTypes) {
        if (this.isSpecial) {
            sortTypes = filter(sortTypes, item => item.Value !== 'Special');
        }

        if (this.isList || this.isFilteredByCategory()) {
            sortTypes = filter(sortTypes, item => item.Value !== 'Aisle');
        }

        return sortTypes;
    }

    isFilteredByCategory() {
        return this.filter && some(this.filter.filters, { Key: 'Category' });
    }

    createTiles(result) {
        return {
            items: this.isSpecial
                ? createProductTiles(result.items)
                : createBundleTiles(result.items),
            totalRecordCount: result.totalRecordCount,
            aggregations: result.aggregations,
        };
    }

    getTiles(pageSize, pageNumber, sortType = 'Name', searchFilter) {
        const cardsPromise = this.isSpecial
            ? this.searchService.doSearchSpecials(this.searchTerm, pageSize, pageNumber, sortType, searchFilter)
            : this.searchService.doSearch(this.searchTerm, pageSize, pageNumber, sortType, !!this.isSpecial, searchFilter);

        return cardsPromise
            .then(result => this.tobaccoCheck(result))
            .then(result => this.createTiles(result))
            .then(result => this.pushAnalytics(result));
    }

    pushAnalytics(result) {
        if (this.searchService.isHeaderSearch) {
            this.searchService.isHeaderSearch = false;
            const searchKeywordType = this.settings.search.suggestionType === 'completion' ? 'SuggestedV3' : 'Suggested';
            this.analyticsService.push({
                data: {
                    trackingType: 'link',
                    searchKeyword: this.searchTerm,
                    listKeywords: this.multisearchItems,
                    searchResult: result,
                    refinementsUsed: 'All Products',
                    searchKeywordType: this.searchService.isAutocompleteSearch ? searchKeywordType : 'Self-typed',
                },
                type: this.analyticsService.mapperTypes.customEvent.search.success,
            });

            this.searchService.isAutocompleteSearch = false;
        }

        return result;
    }

    tobaccoCheck(result) {
        this.pageBannerStateService.setTobaccoBanner(result.hasTobaccoItems);

        return result;
    }

    createAnalyticsData(contentData) {
        return {
            type: this.isSpecial ? 'specials' : 'products',
            categories: this.searchService.categories || '',
            sortOptions: this.sortOptions,
            sortBy: contentData.sortType ? contentData.sortType.Value : '',
            searchKeyword: this.searchTerm,
            listKeywords: this.multisearchItems,
            refinementsUsed: this.filter ? this.filter.filters : '',
            searchResult: contentData,
            pageNumber: this.pageNumber,
        };
    }

    pushContentDataToAnalytics(contentData) {
        this.analyticsService.push({
            data: this.createAnalyticsData(contentData),
            type: this.analyticsService.mapperTypes.search.result,
        });
    }
}

SearchProductTileListController.$inject = ['Settings', 'AnalyticsService', 'SearchService', 'SortByKeys', 'PageBannerStateService'];

const searchProductTileListComponentDefinition = {
    bindings: {
        searchTerm: '<',
        multisearchItems: '<',
        isSpecial: '<',
        isList: '<',
        pageNumber: '<',
        sortBy: '<',
        filter: '<',
    },
    controller: SearchProductTileListController,
    template: `
        <wow-tile-list
            list-title="$ctrl.settings.search.searchHeadingText + ' “' + $ctrl.searchTerm + '”'"
            page-number="$ctrl.pageNumber"
            sort-by="$ctrl.sortBy"
            filter="$ctrl.filter"
            sort-options="$ctrl.sortOptions"
            get-tiles="$ctrl.getTiles(pageSize, pageNumber, sortType, filter)"
            should-remember-sort="::$ctrl.settings.search.shouldRememberSort"
            push-content-to-analytics="$ctrl.pushContentDataToAnalytics(contentData)"
            no-results-term="$ctrl.searchTerm">

            <zero-result>
                <wow-search-zero-results></wow-search-zero-results>
            </zero-result>

            <control>
                <wow-search-term-tile-list-updater
                    search-term="$ctrl.searchTerm">
                </wow-search-term-tile-list-updater>
            </control>
        </wow-tile-list>
    `,
};

module.exports = {
    SearchProductTileListController,
    searchProductTileListComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-product-tile-list.component.js